/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Bar_WomenInputs */

const en_us2_workout_logging_bar_women = /** @type {(inputs: Workout_Logging_Bar_WomenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 kg`)
};

const pt_br2_workout_logging_bar_women = /** @type {(inputs: Workout_Logging_Bar_WomenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 kg`)
};

const es_419_workout_logging_bar_women = /** @type {(inputs: Workout_Logging_Bar_WomenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 kg`)
};

const pt_pt2_workout_logging_bar_women = /** @type {(inputs: Workout_Logging_Bar_WomenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 kg`)
};

const fr_fr2_workout_logging_bar_women = /** @type {(inputs: Workout_Logging_Bar_WomenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 kg`)
};

const de_de2_workout_logging_bar_women = /** @type {(inputs: Workout_Logging_Bar_WomenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 kg`)
};

const it_it2_workout_logging_bar_women = /** @type {(inputs: Workout_Logging_Bar_WomenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 kg`)
};

/**
* | output |
* | --- |
* | "15 kg" |
*
* @param {Workout_Logging_Bar_WomenInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_bar_women = /** @type {((inputs?: Workout_Logging_Bar_WomenInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Bar_WomenInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_bar_women(inputs)
	if (locale === "es-419") return es_419_workout_logging_bar_women(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_bar_women(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_bar_women(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_bar_women(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_bar_women(inputs)
	return en_us2_workout_logging_bar_women(inputs)
});
export { workout_logging_bar_women as "workout-logging.bar_women" }